import { CMS_BASE_URL } from '@/utils/constants';

const resolveImageUrl = ({ raw }: { raw?: string }): string => {
  if (!raw || !CMS_BASE_URL) {
    return '';
  }

  const base = /^(http|https):\/\//.test(raw) ? '' : `${CMS_BASE_URL}/`;

  return `${base}${raw.replace(/^\//, '')}`;
};

export default resolveImageUrl;
